export default "__VITE_ASSET__CMVNZk12__"